<template>
  <div id="app" 
    v-infinite-scroll="mixin_scroll_load_more"
    infinite-scroll-disabled="mixin_scroll_busy"
    infinite-scroll-distance="200">
    <nav-header-mobile v-if="browser_size == 'small' && mixin_is_show_nav_header_mobile"/>
    <router-view v-if="is_router_reload" :key="$route.fullPath" class="app-view"/>
    <nav-tab-mobile v-if="browser_size == 'small' && mixin_is_show_tab_nav"/>
    <tip-toast v-if="!is_applying_apple && !is_applying_google && !mixin_is_hide_tip_toast" :config="tip_toast_config" @close="close_tip_toast"></tip-toast>
    <notifications group="success" classes="vue-notification success" position="top center" />
    <notifications group="error" classes="vue-notification error" position="top center" />
    <notifications position="top center" />
    <modals-container />
    <v-dialog :clickToClose="false" />
    <action-sheet ref="actionsheet"/>

  </div>
</template>
<script>
import { mapState } from 'vuex'
import {
  GET_MY_CHECK,
  GET_MY_NOTICE_BAR,
  POST_OAUTH_MP_REDIRECT_URI,
  POST_OAUTH_MP_CODE,
  POST_OAUTH_MX_REDIRECT_URI,
  POST_OAUTH_MX_CODE,
  GET_MY_ACCOUNT,
  GET_LOGOUT,
} from '@/api/config';
export default {
  name: 'app',
  data() {
    return {
      tip_toast_config: {},
      wx_code: this.$get_url_query('code') || '',
      wx_state:this.$get_url_query('state') || '',
      account: null,
      is_router_reload:true,
      has_auto_login:false,
      ENV:this.GL.ENV,
    };
  },
  provide(){
    return {
      app_router_reload:this.app_router_reload,
      app_action_sheet: this.app_action_sheet
    }
  },
  components: {
  },
  computed: {
    ...mapState('app', [
      'browser_size',
      'auth_token',
      'browser_size',
      'notice_bar_key',
      'is_applying_apple',
      'is_applying_google',
      'afdian_theme',
      'big_event_gray',
      'black_list'
    ]),
  },
  watch: {
    auth_token() {
      this.google_tag(); //google 统计
    },
    session_user(){
      this.load_vconsole()
    },
    $route(v){
      if(v.name == 'oauthWechat'){
          this.auto_login(); //尝试自动登录
      }
      this.deal_big_event_gray()
    },
  },
  beforeMount() {
    document.querySelector('html').setAttribute('class', localStorage.getItem("afdian_theme"))
  },
  async mounted() {
    this.set_client_env(); //设置客户端环境变量

    this.load_vconsole();

    this.$bus.$on('SESSION_EXPIRED', (data) => {
      // 全局监听登录过期
      this.on_expired(data);
    });

    this.auto_login(); //尝试自动登录

    this.init_config(); //初始化配置，并设置打点

    this.window_resize(); //全局监听

    this.on_app_play_info(); //客户端播放媒体信息

    this.watch_document_title(); //监听 document.title

    this.watch_local_storage(); //监听 localStorage

    this.deal_big_event_gray(); //处理监听 灰白纪念日的主题

    this.$bus.$on('SESSION_LOGIN', (auth_token) => {
      //全局监听登录
      this.on_login(auth_token);
    });

    this.$bus.$on('NEED_BIND', (data) => {
      //全局监听 弹出登录
      this.$router.push('/setting/account');
    });

    if (!this.GL.ENV.is_afd_client) {
      this.$bus.$on('POLL_CHECK', () => {
        // 全局监听更新 check
        this.poll_my_check();
      });

      this.open_poll();
    }

    this.$bus.$on('WX_LOGIN', (data) => { //全局监听 wxlogin
      this.wx_login(data ? data.redirect_uri :'')
    });

    this.deal_in_wechat_mini();

    this.deal_app_share_callback(); //app 分享面板里 extra_btns 配置触发的回调

    this.have_fun();

    this.visibilitychange()

    this.full_screen_change()

    this.$bus.$on('TAB_THEME', () => {
      this.on_tab_theme();
    });

    this.$bus.$on('NEED_BIND_PHONE_IN_WECHAT',async () => {
      let re = await this.$mixin_confirm({title:`为了更好的体验，请先绑定手机或邮箱`});
      if(re){
        this.$store.commit('app/set:redirect_url', location.href);
        this.$mixin_router_push(`/login?type=mobile&fr=wx`)
      }
    })
    this.$bus.$on('NEED_BIND_PHONE',async (data = {}) => {
      let re = await this.$mixin_confirm({title:`为了更好的体验，请先绑定手机`});
      if(re){
        this.$store.commit('app/set:redirect_url', this.$route.fullPath);
        this.$mixin_router_push(`/bind?type=phone&redirect=1`);
      }else{
        if(data.is_router_back){
          this.$mixin_router_back();
        }
      }
    })

    this.global_click_listener();
  },
  methods: {
    global_click_listener(){
      document.addEventListener("click", (e) => {
        if(e.target.nodeName == 'A' && e.target.getAttribute('afd-im-href') == '1'){
          this.$mixin_router_push('','',e.target.getAttribute('href'))
          e.preventDefault();
        }
        if(e.target.nodeName == 'IMG' && e.target.getAttribute('afd-big-image') == '1' && e.target.getAttribute('src')){
          this.$mixin_show_modal_img(0, [e.target.getAttribute('src')]);
        }
      });
    },
    visibilitychange(){
        document.addEventListener("visibilitychange", () => {
          let is_show = document.visibilityState === 'visible'
          this.$bus.$emit('VISIBILITYCHANGE', {is_show: is_show});
        });
    },
    full_screen_change(){
      document.addEventListener('webkitfullscreenchange', () => {
        let isFullScreen = document.fullScreen || document.mozFullScreen || document.webkitIsFullScreen
        this.$store.dispatch('app/set:is_full_screen', isFullScreen);
      })
    },
    app_action_sheet(fn,config){
        this.$refs.actionsheet[fn](config)
    },
    app_router_reload(){
      this.is_router_reload = false;
      this.$nextTick(() => {
        this.is_router_reload = true;
      })
    },
    on_app_play_info(){
        window.app_play_info = (data) => {
            console.log(data)
            this.$bus.$emit('APP_PLAY_INFO', data);
        }
        // window.play_info = window.app_play_info;
        // id:’xxx’， //post_id
        // type：’audio’  || ‘video’
        // status:  'playing' || 'stop' ||  ‘pause’,
        // time_at: 111 //ms   数值类型，播放毫秒
        // duration: 111 //ms  数值类型，时长毫秒
        // url:'xxx'
    },
    set_client_env() {
      this.$store.dispatch('app/set:client_env');
    },
    watch_local_storage(){
      this.$bus.$on('APP_LOCAL_STORAGE_CHANGE', (data) =>{
        if(this.GL.ENV.is_afd_client){
          this.$bridge.call("local_storage_change", { key:data.key, val: data.val}, e => {});
        }
      })
      window.addEventListener('storage',(e) => {
          if(e.key && e.key == 'afdian_theme'){
            this.$store.dispatch('app/set:afdian_theme', e.newValue);
            document.querySelector('html').setAttribute('class', e.newValue)
            this.$bus.$emit('LOCAL_STORAGE_CHANGE',{key: 'afdian_theme', val: e.newValue}) //通知其他web界面
          }
      });
    },
    watch_document_title(){
      const targetNode = document.querySelector('title')
      const config = { attributes: true, childList: true, subtree: true };
      const observer = new MutationObserver((mutationsList) => {
        // console.log(mutations)
        for(let mutation of mutationsList) {
            if (mutation.type === 'childList') {
                // console.log('A child node has been added or removed.');
                this.$bus.$emit('DOCUMENT_TITLE_CHANGE', mutation);
            }
            else if (mutation.type === 'attributes') {
                this.$bus.$emit('DOCUMENT_TITLE_CHANGE', mutation);
            }
        }
      });
      // 以上述配置开始观察目标节点
      observer.observe(targetNode, config);
    },
    window_resize() {
      let w = document.body.clientWidth;
      this.handle_resize(w);
      window.addEventListener('resize', (e) => {
        let w = document.body.clientWidth;
        this.handle_resize(w);
        this.$bus.$emit('WINDOW_RESIZE', e);
      });
    },
    handle_resize(w) {
      if (w < 869) {
        this.$store.dispatch('app/set:browser_size', 'small');
      }
      if (w >= 869 && w <= 1000) {
        this.$store.dispatch('app/set:browser_size', 'middle');
      }
      if (w > 1000) {
        this.$store.dispatch('app/set:browser_size', 'large');
      }
    },
    google_tag() {
        //   console.log(this.session_user.user_id)
        //   console.log(gtag)

    //   if(!this.is_pro){
    //     return false;
    //   }
      if (typeof gtag != 'undefined' && this.session_user) {
        // gtag('set', { user_id: this.session_user.user_id });
        // console.log(1112222)
        // gtag('config', 'UA-116694640-1', {
        //     'user_id': this.session_user.user_id,
        // });
      }
    },
    on_login(auth_token) {
      this.$store.dispatch('app/set:auth_token', auth_token);
      this.$cookies.set('auth_token', auth_token, { expires: 30 * 12 }); //1年
      this.$store.dispatch('app/set:session_user');
      this.$store.dispatch('app/set:bind_account');
    },
    async on_expired(data = {}) {
      console.log('SESSION_EXPIRED');
      if(data.is_request_logout){
        await this.logout()
      }
      // 
      localStorage.removeItem('user_id')
      this.$store.dispatch('app/set:auth_token', '');
      this.$cookies.remove('auth_token');
      this.$store.dispatch('app/del:session_user');
      this.$store.dispatch('app/set:bind_wechat_account', null);
    },
    open_poll() {
      this.poll_my_check();
      setInterval(() => {
        this.poll_my_check(); //全局轮询
      }, 1000 * 60);
    },
    async poll_my_check() {
      if (this.$http.is_run(GET_MY_CHECK)) {
        return false;
      }
      let data = await this.$http.$axios(GET_MY_CHECK);
      if (data.ec == 200) {
        this.$store.dispatch(
          'app/set:unread_message_num',
          data.data.unread_message_num
        );
        this.$store.dispatch(
          'app/set:unread_post_num',
          data.data.unread_post_num
        );
        this.$store.dispatch('app/set:unread_count', data.data.unread_count);
        let fav_path = data.data.unread_message_num > 0 ? `${this.GL.PIC_HOST}/static/img/favicon/favicon-red.ico` : `https://static.afdiancdn.com/favicon.ico`
        document.querySelector('link[rel="shortcut icon"]').setAttribute('href',fav_path)
      }
      if (this.notice_bar_key != data.data.notice_bar_key) {
        this.$store.dispatch(
          'app/set:notice_bar_key',
          data.data.notice_bar_key
        );
        this.call_tip_toast(data.data.notice_bar_key);
      }
      if(data.data.ip_info != undefined){
          this.$set(this.GL.ENV,'is_abroad',data.data.ip_info.is_abroad)
          this.$set(this.GL.ENV,'is_abroad',1)
      }

    },
    async wx_login_redirect(redirect_uri = '') {
      const API = this.GL.ENV.is_wechat ? POST_OAUTH_MP_REDIRECT_URI : POST_OAUTH_MX_REDIRECT_URI
      if (this.$http.is_run(API)) {
        return false;
      }
      let uri = redirect_uri || location.href;
      uri = encodeURIComponent(uri)
      // if(uri.indexOf('2bed100cf5e111ec90c852540025c377') !=- 1 || uri.indexOf('98e606aa362811e883e952540025c377') !=- 1){
      //   uri = encodeURIComponent(uri)
      //   console.log('转移了')
      // }  

      let data = await this.$http.$axios(API, {
        redirect_uri: uri,
      });
      if (data.ec != 200) {
        this.$notify({
          title: data.em,
          group: 'error',
        });
        return false;
      }
      if (data.ec == 200) {
        if(redirect_uri && !this.GL.ENV.is_mobile){
            if(window.afd_wx_login_window){
                window.afd_wx_login_window.location = data.data.url;
                return false
            }
            // return false
        }
        console.log(data.data.url)
        location.href = data.data.url;
        // location.href  = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx9a3a94c374a78081&redirect_uri=http%3A%2F%2F74db138637d611e887f852540025c377.afdian.net%2F&response_type=code&scope=snsapi_userinfo&state=`
      }
    },
    deal_big_event_gray(){
      if(this.big_event_gray.length > 0 && !this.ENV.is_abroad){
        let html_dom = document.querySelector('html');
        if(this.big_event_gray.indexOf(this.$route.name) != -1){
          html_dom.setAttribute('big-event-gray', 1)
          return 0
        }
        html_dom.removeAttribute('big-event-gray')
      }
    },
    del_query_code(){
      if(this.$route.name == 'orderCreate'){
        let newQuery = JSON.parse(JSON.stringify(this.$route.query))
        delete newQuery.code
        this.$router.replace({ query: newQuery })
        console.log('del_query_code')
      }
    },
    async wx_login_mp_token() {
      const API = this.GL.ENV.is_wechat ? POST_OAUTH_MP_CODE : POST_OAUTH_MX_CODE

      if (this.$http.is_run(API)) {
        return false;
      }
      let data = await this.$http.$axios(API, {
        code: this.wx_code,
      });
      if (data.ec != 200) {
        this.$notify({
          title: data.em,
          group: 'error',
        });
        return false;
      }
      if (data.ec == 200) {
        this.wx_code = '';
        this.del_query_code(); //为了支付页不影响 微信支付的code
        
        let d = data.data;
        if (d.mp_profile) {
          this.$store.dispatch('app/set:mp_profile', d.mp_profile);
        }
        if (d.mp_token) {
          this.$store.dispatch('app/set:mp_token', d.mp_token);
        }
        if (d.auth_token) {
          this.on_login(d.auth_token);
        }
        if(window.opener){
            window.opener.location.reload();
            if(window.opener.afd_wx_login_window){
                window.opener.afd_wx_login_window.close()
            }
            if(window.afd_wx_login_window){
                window.afd_wx_login_window.close()
            }
        }
      }
    },
    async auto_login() {
    //   if(this.has_auto_login){
    //       return false;
    //   }
    //   if(this.$route.name != 'oauthWechat'){ //这个页需要单独打开
    //     this.has_auto_login = true;
    //   }
      let auth_token = this.$cookies.get('auth_token');
      if (auth_token) {
        // 登录态自动获取session_user
        await this.$store.dispatch('app/set:session_user'); //此处一定先登录， auth_token 的变化已经登录态判断
        await this.$store.dispatch('app/set:auth_token', auth_token);
      } else {
        localStorage.removeItem('user_id')
        await this.$store.dispatch('app/set:auth_token', '');
      }

      if (this.session_user) {
        this.$store.dispatch('app/set:bind_account');
      }

      if (this.GL.ENV.is_wechat && this.session_user) {
        //已登录 微信授权
        await this.get_my_account();
        if (this.account && this.account.oauth && !this.account.oauth.wechat) {
        //   this.wx_login();
        }
      }
      if(this.session_user && this.session_user.has_bind_phone == 0){
        //   if(['index','orderCheck'].indexOf(this.$route.name) == -1){
        //     this.$router.push(`/login?type=mobile&fr=wx`)
        //   }
      }
      if (this.GL.ENV.is_wechat && this.wx_code && !this.session_user) {
        //mobile 未登录 微信授权
        this.wx_login();
      }

      if (this.wx_code && this.$route.name == 'oauthWechat' && location.href.indexOf('state') != -1) {
        //PC 微信授权
        this.wx_login();
      }
    },
    wx_login(redirect_uri = '') {
      if (this.wx_code == '') {
        this.wx_login_redirect(redirect_uri);
      } else {
        this.wx_login_mp_token();
      }
    },
    on_tab_theme(){
      let val = this.afdian_theme  == 'dark' ? '' : 'dark'
      localStorage.setItem("afdian_theme", val);
      this.$store.dispatch('app/set:afdian_theme', val);
      this.$bus.$emit('APP_LOCAL_STORAGE_CHANGE', {key:'afdian_theme', val}) //通知客户端
      document.querySelector('html').setAttribute('class', val)
    },
    async get_my_account() {
      if (this.$http.is_run(GET_MY_ACCOUNT)) {
        return false;
      }
      let data = await this.$http.$axios(GET_MY_ACCOUNT);
      if (data.ec == 200) {
        this.account = data.data;
      }
    },
    async logout() {
      // if (this.$http.is_run(GET_LOGOUT)) {
      //   return false;
      // }
      // localStorage.removeItem('user_id')
      // await this.$http.$axios(GET_LOGOUT);
    },
    async init_config() {
      let init_config = localStorage.getItem('init_config');
      if (!init_config) {
        await this.$store.dispatch('app/set:init_config');
        this.$router.log(); //自定义打点
      }
    },
    async call_tip_toast(key) {
      if (this.$http.is_run(GET_MY_NOTICE_BAR)) {
        return false;
      }
      let data = await this.$http.$axios(GET_MY_NOTICE_BAR);

      if (data.ec != 200) {
        this.$notify({
          title: data.em,
          group: 'error',
        });
        return false;
      }
      if (data.data.list.length == 0) {
        this.tip_toast_config = {};
        return false;
      }
      let d = data.data.list[0];
      if (localStorage.getItem('notice_bar_id') != d.id) {
        d.is_show = true;
        d.notice_bar_key = key;
        this.tip_toast_config = d;
      }
    },
    close_tip_toast(config) {
      localStorage.setItem('notice_bar_key', config.notice_bar_key);
      localStorage.setItem('notice_bar_id', config.id); //记录已经关闭的消息
      this.tip_toast_config = {};
    },
    deal_in_wechat_mini() {
      if (this.GL.ENV.is_wechat_mini) {
        document.querySelectorAll('meta[name="theme-color"]')[0].remove(0); //android 下会顶部变白
      }
    },
    have_fun() {
      console.log(
        '%c爱发电',
        'color:rgba(148,108,230,1);text-shadow: 0 1px 1px #bbb;font-size:16px'
      );
      console.log(
        '赞助一下：%chttps://afdian.net/a/afdian',
        'color:rgba(148,108,230,1)'
      );
    },
    deal_app_share_callback() {
      if (this.GL.ENV.is_afd_client) {
        ['share_user','share_badge', 'share_post', 'share_album', 'share_group', 'share_shop', 'share_shop_item'].forEach(
          (v) => {
            if(v == 'share_badge'){
                window[v] = async (data) => {
                  let o = window.share_badge_dom;
                  let scale = Math.min(3, parseInt(window.devicePixelRatio));
                  if(this.GL.ENV.ios_version >= 15){
                      o.className = o.className + ' no-ios-font' //兼容ios 15
                  }
                  let img = await this.mixin_make_pic(o, scale);
                  this.$mixin_show_modal_img(0,[img.src],"0","请长按图片保存",false);
                  // this.$mixin_make_download(img.src, data.filename || "share");
                  this.$emit("close");
                };
                return false;
            }
            window[v] = (data) => {
              this.$mixin_show_modal_share_img(data);
            };
          }
        );
      }
      window.share_thank = (data) => {
        this.$nextTick(async () => {
          let img = await this.mixin_make_pic(document.getElementById(data.dom_id), 3);
          this.$mixin_show_modal_img(0, [img.src], '0', '请长按图片保存', false);
        });
      };
    },
    // load_wx_sdk(){
    //     const s = document.createElement('script');
    //     s.type = 'text/javascript';
    //     s.async = 'async'
    //     s.src = 'https://res.wx.qq.com/open/js/jweixin-1.6.0.js';
    //     document.body.appendChild(s);
    //     s.onload = () =>{
    //         wx.config({
    //             debug: true, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
    //             appId: 'wxcb5ad103c3e166e4', // 必填，公众号的唯一标识
    //             timestamp: '', // 必填，生成签名的时间戳
    //             nonceStr: '', // 必填，生成签名的随机串
    //             signature: '',// 必填，签名
    //             jsApiList: [] // 必填，需要使用的JS接口列表
    //         });
    //     }
    // },
    async load_vconsole() {
      if(this.GL.vConsole){
          return false;
      }
      if (this.GL.ENV.is_beta || this.session_user && (this.session_user.user_id == '179f19102e7111e8bf4d52540025c377' || this.session_user.user_id == '80a0b7b47ff211ea990952540025c377')) {
        let vConsole = await import('vconsole');
        this.GL.vConsole = vConsole.default;
        window.GL = this.GL;
        new this.GL.vConsole();
      }
    },
  },
};
</script>
<style lang="stylus">
#app {
  min-height: 100%;
  &.dark{
    filter: invert(1) hue-rotate(180deg);
    transition: color 300ms, background-color 300ms;
  }
  .app-view {
    overflow-x: hidden;
    min-height: 100%;

    /* overflow-y auto */
    &::-webkit-scrollbar {
      width: 0;
      background: transparent;
      display: none;
    }

    // &.transition-slide {
    //   transition: transform 0.4s cubic-bezier(0.55, 0, 0.1, 1);

    //   &.slide-left-enter {
    //     transform: translate(100%, 0);
    //   }

    //   &.slide-right-enter {
    //     transform: translate(-100%, 0);
    //   }

    //   &.slide-right-leave-active {
    //     transform: translate(100%, 0);
    //   }

    //   &.slide-left-leave-active {
    //     transform: translate(-100%, 0);
    //   }
    // }

    // &.transition-fade {
    //   opacity: 1;
    //   transition: opacity 0s ease;

    //   &.fade-enter {
    //     opacity: 0;
    //   }

    //   &.fade-leave-active {
    //     opacity: 0;
    //   }
    // }
  }
}
</style>
